<template id="tipnotes">
        <span>
          <slot :text="redval"></slot>
        </span>
</template>

<script>
export default {
    name: 'tipnotes',
    componentName: 'tipnotes',
    template: '#tipnotes',
    props: ['redval']
}
</script>
<style scoped>
.redtip{ border-radius: 50%; font-style: normal; color: #fff; display: inline-block; width: 1.5em; height: 1.2em; text-align: center; line-height: 1.2em; font-size: 0.8em;}
.bg-danger{margin-left: 89px; padding: 0 4px;height: 16px;line-height: 16px;border-radius: 10px;background-color: #e54545;color: #fff;font-size: 12px;
    /* position: absolute;
    top: 0;
    right: -10px;
    display: inline-block;vertical-align: 10px;
     */
}
</style>



// WEBPACK FOOTER //
// tipnotes.vue?3eabfcfe